// Componenet imports
import { User } from 'firebase/auth'
import Layout from '../components/layout'
import MainTitle from '../components/main_title'

import { auth, db } from '../firebase'
import { getDoc, doc, updateDoc } from 'firebase/firestore'
import { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { IUserInfo, emptyui } from '../types/user_info'

function Profile() {
  const user = auth.currentUser as User
  const [userInfo, setUserInfo] = useState<IUserInfo>(emptyui)

  useEffect(() => {
    const fetchName = async () => {
      const docRef = doc(db, 'Users', user.uid)
      const docSnap = await getDoc(docRef)

      if (docSnap.exists()) {
        // console.log(JSON.stringify(docSnap.data())))
        setUserInfo(docSnap.data() as IUserInfo)
      }
    }
    fetchName()
  }, [user.uid])

  const updateUserInfo = async () => {
    const ref = doc(db, 'Users', user.uid)
    await updateDoc(ref, { ...userInfo })
    toast.success('Successfully Updated the User Info')
  }

  return (
    <Layout>
      <MainTitle title={`Profile: ${userInfo.name}`} />
      <div className="mb-10 w-full rounded-2xl bg-primary p-10">
        <div className="text-2xl">Account Information</div>

        <div className="my-4">
          <div className="">Email</div>
          <input
            type="input"
            className="my-2 w-full rounded-xl p-2"
            value={userInfo.email}
            onChange={(e) =>
              setUserInfo({ ...userInfo, email: e.target.value })
            }
          />
        </div>

        <div className="my-4">
          <div className="">Name</div>
          <input
            type="input"
            className="my-2 w-full rounded-xl p-2"
            value={userInfo.name}
            onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })}
          />
        </div>

        <div className="my-4">
          <div className="">Phone Number</div>
          <input
            type="input"
            className="my-2 w-full rounded-xl p-2"
            value={userInfo.phone}
            onChange={(e) =>
              setUserInfo({ ...userInfo, phone: e.target.value })
            }
          />
        </div>

        <div className="my-4">
          <div className="">Location</div>
          <input
            type="input"
            className="my-2 w-full rounded-xl p-2"
            value={userInfo.location}
            onChange={(e) =>
              setUserInfo({ ...userInfo, location: e.target.value })
            }
          />
        </div>
      </div>
      <div className="flex flex-row-reverse">
        <button
          className="rounded-2xl bg-secondary py-2 px-6 text-white hover:bg-tertiary"
          onClick={updateUserInfo}
        >
          Save
        </button>
      </div>
    </Layout>
  )
}

export default Profile
